import { useState } from "react";
import AMLDropdownmenu from "../aml-anomaly-detection/AmlDropdownmenu";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@components/ui/table";
import { Label } from "@components/ui/label";
import { Checkbox } from "@components/ui/checkbox";
import AnomalyFixedDialog from "../aml-anomaly-detection/AnomalyFixedDialog";
import { Button } from "@components/ui/button";
import { ChevronsDown } from "lucide-react";
import { toast } from "@components/ui/use-toast";

type anomaliesDataType = {
  select: React.ReactNode;
  category: string;
  type: string;
  description: string;
  score: number;
  time: string;
  groupAnom: boolean;
  expandAnomaly: anomaliesDataType[] | HTMLElement;
  id?: string;
  anomaly_id?: string;
  anomalyId?: string;
  globalID?: string;
  epochTime?: number;
  time_seen?: number;
  desc?: string;
  dip?: string;
  dport?: string;
  ip?: string;
  sport?: string;
  sip?: string;
  smac?: string;
  data?: any;
  expandDetails?: string;
  events?: React.ReactNode;
  sensor?: string;
};

type anomaliesColType = {
  header: string;
  accessor: string;
  type?: string;
};

function TableRowNew({
  data,
  cols,
  isSelected = false,
  onCheckSelect,
}: {
  data: anomaliesDataType;
  cols: anomaliesColType[];
  isSelected?: boolean;
  onCheckSelect: any;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <tr className="">
        <td className="py-1.5 align-top w-[80px]">
          <Checkbox
            className="me-4 mt-2"
            checked={isSelected}
            onCheckedChange={(e) =>
              onCheckSelect(e, data.data.globalID, data.data.epochTime)
            }
          />
        </td>
        {cols.map((header: anomaliesColType, index: number) => {
          const rowData = data as Record<string, any>;
          const nestedData = (data.data ?? {}) as Record<string, any>;
          const cellValue =
            rowData[header.accessor] !== undefined
              ? rowData[header.accessor]
              : nestedData[header.accessor];
          return (
            <td
              key={index}
              className={`py-3 pe-3 align-top ${
                header.accessor === "description" ||
                header.accessor === "events"
                  ? "max-w-[20%]"
                  : header.accessor === "score"
                    ? "w-[130px]"
                    : header.accessor === "time"
                      ? "w-[145px]"
                      : ""
              }`}
            >
              {header.accessor === "time" ? (
                <div className="whitespace-nowrap flex w-full justify-between">
                  {cellValue}{" "}
                  <span className="hidden" onClick={handleExpandClick}>
                    <ChevronsDown
                      size={14}
                      className="cursor-pointer inline-block text-primary stroke-5"
                    />
                  </span>
                </div>
              ) : (
                cellValue
              )}
            </td>
          );
        })}
        {/* <td className="py-3 pe-3 align-top">{data.category}</td>
        <td className="py-3 pe-3 align-top">{data.type}</td>
        <td className="py-3 pe-3 align-top max-w-[20%] ">{data.description}</td>
        <td className="py-3 pe-3 align-top max-w-[20%] ">{data.events}</td>
        <td className="py-3 pe-3 align-top w-[130px]">{data.score}</td>
        <td className="py-3 pe-3 align-top w-[145px]">
          <div className="whitespace-nowrap flex w-full justify-between">
            {data.time}{" "}
            <span className="hidden" onClick={handleExpandClick}>
              <ChevronsDown
                size={14}
                className="cursor-pointer inline-block text-primary stroke-5"
              />
            </span>
          </div>
        </td>
        <td className="py-3 pe-3 align-top w-[130px]">{data.data.sensor}</td>*/}
        {/* <td ></td> */}
        {/* other td elements */}
      </tr>
      {isExpanded && (
        <tr className="caption-bottom text-sm overflow-x-hidden bg-primary-background">
          <td colSpan={6}>
            <table className="m-auto w-[80%] max-w-[850px]">
              <tbody>
                {data.groupAnom == true && Array.isArray(data.expandAnomaly) ? (
                  data.expandAnomaly.map(
                    (newRow: anomaliesDataType, index: number) => (
                      <ExpandableContent key={index} data={newRow} />
                    ),
                  )
                ) : (
                  <tr>
                    <td>{data.expandDetails}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </>
  );
}

function ExpandableContent({ data }: { data: anomaliesDataType }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };
  const passdata = data;
  passdata["anomalyId"] = passdata.anomaly_id;
  passdata["globalID"] = passdata.id;
  // passdata["anomalyId"] = passdata.id;
  passdata["time_seen"] = passdata.epochTime;
  // Render the expanded content here, using the provided data
  return (
    <>
      <tr>
        {/* <td className='w-[10%]'></td> */}
        <td className="py-3 align-top">
          <div className="whitespace-nowrap">
            <div className="inline-block me-2">
              <AMLDropdownmenu data={passdata} isModal={true} />
            </div>
            <div className="inline-block">{data.time}</div>
          </div>
        </td>
        <td className="py-3 align-top">
          <div className="px-5">{data.desc}</div>
        </td>
        <td className="py-3 align-top">
          <div className="whitespace-nowrap flex w-full justify-between">
            {data.score}
            <span onClick={handleExpandClick}>
              <ChevronsDown
                size={14}
                className="cursor-pointer inline-block text-primary ml-2 stroke-5"
              />
            </span>
          </div>
        </td>
        {/* <td className='w-[10%]'></td> */}
      </tr>
      {isExpanded && (
        <tr>
          <td className="py-1.5 align-top"></td>
          <td className="py-1.5 align-top">
            <ul className="detail list-disc text-base w-3/4">
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Remote IP</span> :{" "}
                <span className="">{data.dip}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Remote Port</span> :{" "}
                <span className="">{data.dport}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Local IP</span> :{" "}
                <span className="">{data.ip}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Local Port</span> :{" "}
                <span className="">{data.sport}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Observed Behaviors</span> :{" "}
                <span className="">{data.desc}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Source IP</span> :{" "}
                <span className="">{data.sip}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Source MAC</span> :{" "}
                <span className="">{data.smac}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">User Agent</span> :{" "}
                <span className="">{data.data["User Agent"]}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">Destination IP</span> :{" "}
                <span className="">{data.dip}</span>
              </li>
              <li className="text-sm pb-0.5 break-all">
                <span className="text-primary">URI</span> :{" "}
                <span className="">{data.data.display.URI}</span>
              </li>
            </ul>
          </td>

          <td className="py-1.5 align-top"></td>
        </tr>
      )}
    </>
  );
}

function DataTableAnomaly({
  data,
  cols,
  type = "anomaly",
}: {
  data: anomaliesDataType[];
  cols: anomaliesColType[];
  type?: "anomaly" | "alert";
}) {
  const [actionData, setActionData] = useState<any>([]);
  const [openDialog, setOpenDialog] = useState(false);

  function setData(e: boolean, gid: number, time: number) {
    if (e) {
      setActionData((prev: any) => [...prev, { anomalyId: gid, time: time }]);
    } else {
      setActionData((prev: any) =>
        prev.filter((item: any) => item.anomalyId !== gid),
      );
    }
  }

  function showFixDialog() {
    if (actionData.length > 0) {
      setOpenDialog(true);
    } else {
      toast({
        title: "Error",
        description: `Please select at least one ${type} to fix.`,
        variant: "destructive",
      });
    }
  }

  const selectionHandle = (s: boolean) => {
    if (s) {
      setActionData(
        data.map((e) => ({
          anomalyId: e.data.globalID,
          time: e.data.epochTime,
        })),
      );
    } else {
      setActionData([]);
    }
  };

  return (
    <>
      <AnomalyFixedDialog
        action={`fix${type}`}
        anomalyType="Entity"
        show={openDialog}
        onClose={() => setOpenDialog(false)}
        anomalyData={actionData}
      />
      <div>
        <div className="flex items-center">
          <div className="mr-4 flex items-center">
            <Checkbox id="terms" onCheckedChange={selectionHandle} />
            <Label
              htmlFor="terms"
              className="ml-2 text-sm font-medium leading-none"
            >
              Select/Unselect all
            </Label>
          </div>
          <Button className="mb-2" onClick={() => showFixDialog()}>
            Fix Selected {type == "alert" ? "Alerts" : "Anomalies"}
          </Button>
        </div>
        <Table className={"overflow-x-hidden w-full "}>
          <TableHeader>
            <TableRow key={0}>
              <TableHead className={`px-0 text-xs`}>Action</TableHead>
              {cols.map((header: anomaliesColType, index: number) => (
                <TableHead key={index} className={`px-0 text-xs`}>
                  {header.header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row: anomaliesDataType, index: number) => (
              <TableRowNew
                key={index}
                data={row}
                cols={cols}
                isSelected={actionData.some(
                  (item: any) => item.anomalyId === row.data.globalID,
                )}
                onCheckSelect={(e: boolean, gid: number, time: number) =>
                  setData(e, gid, time)
                }
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

export default DataTableAnomaly;
